import VerifyEmailForm from './VerifyEmailForm';

export default VerifyEmailForm;
